<!--
* @Description:
* @Date: 2024-12-03 15:55:01
-->
<template>
  <div class="">
    <BaseForm
      :label-position="labelPosition"
      label-width="200px"
      :model="formData"
      ref="ruleFormRef"
      :disabled="disabled"
    >
      <BaseFormItem :rules="rulesFrom" :label="label" prop="data">
        <BaseInput
          v-if="type === 'number'"
          style="width: 310px"
          v-model="formData.data"
          :maxlength="maxlength"
          show-word-limit
          type="text"
          :placeholder="placeholder"
          @input="handleInput"
        ></BaseInput>
        <BaseInput
          v-else
          style="width: 310px"
          v-model="formData.data"
          :maxlength="maxlength"
          show-word-limit
          :type="type"
          :rows="rows"
          :placeholder="placeholder"
          :inputTextReplace="inputTextReplace"
          :inputTexts="inputTexts"
        ></BaseInput>
      </BaseFormItem>
    </BaseForm>
  </div>
</template>

<script lang="ts" setup>
import { BaseForm, BaseFormItem, BaseInput, BaseFormRef } from 'xrk-components';
import {
  reactive,
  ref,
  defineExpose,
  defineProps,
  withDefaults,
  computed,
  watch
} from 'vue';
const ruleFormRef = ref<BaseFormRef>();
const props = withDefaults(
  defineProps<{
    placeholder: string;
    label: string;
    maxlength: string | number;
    ruleValidator: (
      rule: any,
      value: any,
      callback: (error?: string | Error) => void
    ) => void;
    type: 'number' | 'textarea' | 'text' | 'password' | 'tel';
    disabled: boolean;
    rows: number;
    defaultValue: number | string;
    labelPosition: 'left' | 'right' | 'top';
    inputTexts: string[];
    inputTextReplace: boolean;
  }>(),
  {
    inputTextReplace: false,
    labelPosition: 'top',
    disabled: false,
    rows: 7
  }
);

// 添加处理输入的方法
const handleInput = (value: string) => {
  // 使用正则表达式限制只能输入两位小数的数字
  const regex = /^\d+(\.\d{0,2})?$/;
  if (value && !regex.test(value)) {
    // 如果不符合规则，可以进行处理（如截取或替换）
    const validValue = value.match(/^\d+(\.\d{0,2})?/);
    if (validValue) {
      formData.data = validValue[0];
    } else {
      formData.data = value
        .replace(/[^\d.]/g, '')
        .replace(/^(\d+\.\d{2}).*$/, '$1');
    }
  }
};

let formData = reactive<{ data: any }>({
  data: props.defaultValue ? props.defaultValue : ''
});
watch(
  () => formData.data,
  val => {
    if (val == null) {
      formData.data = '';
    }
  }
);
const rulesFrom = computed(() => {
  return [
    {
      required: true,
      validator: props.ruleValidator as (
        rule: any,
        value: any,
        callback: (error?: string | Error) => void
      ) => void,
      trigger: 'change'
    }
  ];
});

defineExpose({
  getFormData: () => {
    return new Promise((reslve, reject) => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          reslve(formData);
        } else {
          reject('error submit!');
        }
      });
    });
  }
});
</script>

<style lang="scss" scoped></style>
